import React, { lazy } from "react";
import { withRouter } from "react-router-dom";
import Swal from "sweetalert2";
import {
  getToday,
  isPos,
  localStoragedecryp,
  localStorageencryp,
  setItem,
} from "../../components/helpers/function.jsx";
// import { ToastNotification } from "../../components/helpers/notification.jsx";
import { getData, postData } from "../../config/axios.jsx";
import { PageSettings } from "../../config/page-settings.js";
import { ToastNotification } from "../../components/helpers/notification.jsx";
import { isPusat } from "../../components/helpers/library.jsx";
const FormLogin = lazy(() => import("./FormLogin.jsx"));
// const Address = process.env.REACT_APP_ADDRESS;

class Login extends React.Component {
  static contextType = PageSettings;

  constructor(props) {
    super(props);
    this.state = {
      isLoading: false,
      // isLogin: false,
      // alamat : ""
    };
  }

  state = {
    date: "",
  };

  getDate = () => {
    var date = new Date().toDateString();
    this.setState({ date });
  };

  componentDidMount() {
    localStorage.setItem('base_url', JSON.stringify(window.location.href))
    const isAuthenticated = localStoragedecryp("islogin");
    if (isAuthenticated === getToday()) {
      this.props.history.push("/dashboard");
    }
    window.history.pushState(null, document.title, window.location.href);
    window.addEventListener("popstate", function (event) {
      window.history.pushState(null, document.title, window.location.href);
    });

    this.context.handleSetPageSidebar(false);
    this.context.handleSetPageHeader(false);
    this.context.handleSetBodyWhiteBg(true);
    this.getDate();
    // console.log(encryptascii('sa'));
    // console.log(decryptascii('BF95'));
    getData('system/get').then((res) => {
      // console.log(res.data[0].alamat_toko);
      let row = {
        alamat_toko: res.data[0].alamat_toko,
        nama_toko: res.data[0].nama_toko
      }
      setItem('data_toko', row)

      this.setState({
        alamat_toko: res.data[0].alamat_toko,
        nama_toko: res.data[0].nama_toko
      })
    }).catch((err) => {
      this.setState({
        alamat_toko: "",
        nama_toko: ""
      })
    })
  }

  componentWillUnmount() {
    this.context.handleSetPageSidebar(true);
    this.context.handleSetPageHeader(true);
    this.context.handleSetBodyWhiteBg(false);
  }

  async getMenuByUserId(data) {
    // console.log('userid')
    try {
      let res = await getData("akses-user-v2?user_id=" + data.user_id);
      let menu = [];
      res.data.forEach((row) => {
        if (row.is_show) {
          if (row.children.length === 0) {
            let hasil1 = {
              icon: row.icon,
              is_show: row.is_show,
              path: row.path,
              title: row.title,
              user_id: row.user_id,
              __v: row.__v,
              _id: row._id
            };
            menu.push(hasil1);
          } else {
            let menuChildern = row.children.map((list) => {
              let children = Array.isArray(list.children)
                ? list.children.filter((child) => child.is_show)
                : undefined;
              return {
                ...list,
                children
              };
            });

            let hasil = {
              ...row,
              children: menuChildern.filter((child) => child.is_show)
            };
            menu.push(hasil);
          }
        }
      });
      setItem("menu", menu);
      setTimeout(() => {
        this.props.history.push(
          isPos()
            ? "/home"
            : isPusat === "PUSAT"
              ? "/dashboardPusat"
              : "/dashboard"
        );
        this.setState({ isLoading: false });
        window.location.reload();
      }, 1000);
    } catch (err) {
      console.log(err);
      ToastNotification(
        "info",
        err?.response?.data?.message || "Terjadi Kesalahan Saat Request Data"
      );
      this.setState({ isLoading: false });
    }
  }

  onfiled(err) {
    // NotifError(err)
    console.log(err);
    Swal.fire({
      title: "Oopss !!!",
      text: err.response === undefined ? 'Terjadi Kesalahan Saat Request Data' : err.response.data,
      icon: "info",
    });
    this.setState({ isLoading: false });
  }
  async onSubmit(data) {
    let hasil = {
      user_id: data.user_id,
      password: data.password,
    };
    this.setState({ isLoading: true });
    postData("users/login", hasil)
      .then(async (resposn) => {
        localStorageencryp("userdata", JSON.stringify(resposn.data));
        localStorageencryp("token", resposn.data.token);
        localStorageencryp("islogin", getToday());
        document.getElementById("logindata").value = data.user_id;
        getData('para-system/type/module').then((res) => {
          // console.log(res);
          setItem('module', (res.data.filter((list) => list.value === 'true')))
        })
        // await this.cekLisensiValidator(resdata);
        // await getModule(resdata);
        await this.getMenuByUserId(data);
      }).then(() => {
        // this.TextFilenotapesanan()
        // getData('akses-user/id/'+data.user_id).then((res) => {
        //   localStorage.setItem('menu',JSON.stringify(res.data))
        // }).catch((err) => {
        //   // ToastNotification("info",err.?response.data)
        // })
      })
      .then(() =>
        setTimeout(() => {
          this.props.history.push("/dashboard");
          this.setState({ isLoading: false });
          window.location.reload();
        }, 1000)
      )
      .catch((err) => this.onfiled(err));
  }

  TextFilenotapesanan() {
    const element = document.createElement("a");
    const file = new Blob([document.getElementById("logindata").value], {
      type: "text/plain;charset=utf-8",
    });
    element.href = URL.createObjectURL(file);
    element.download = "timbangan.txt";
    document.body.appendChild(element);
    element.click();
  }
  render() {
    return (
      <div className="login login-with-news-feed">

        <div className="news-feed">
          <div
            className="news-image"
            style={{
              backgroundImage: `url(${require("../../assets/img/login-bg/backround-kresno.png")})`,
            }}
          ></div>
          <div className="news-caption text-center">
            <textarea
              style={{ display: "none" }}
              id="logindata"
              rows="100"
              cols="100"
            />
            {/* <h4 className="caption-title">
              <b>Toko</b> Mas Kresno
            </h4> */}
            <p>
              {this.state.alamat_toko}
            </p>
          </div>
        </div>
        <div className="right-content">
          <FormLogin
            isLoading={this.state.isLoading}
            nama_toko={this.state.nama_toko}
            onSubmit={(data) => this.onSubmit(data)}
          />
        </div>
      </div>
    );
  }
}

export default withRouter(Login);